import { useEffect } from "react";

const CANONICAL_BASE = "https://infantsleepconsultantnearme.com";

// Sets title/meta/canonical. Private routes pass noindex to keep portal/dashboards out of search.
export function useSeo({ title, description, canonical, noindex = false }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (attr, key, val) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
      el.setAttribute("content", val);
    };
    if (description) { setMeta("name", "description", description); setMeta("property", "og:description", description); }
    if (title) setMeta("property", "og:title", title);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.setAttribute("rel", "canonical"); document.head.appendChild(link); }
    link.setAttribute("href", canonical ? `${CANONICAL_BASE}${canonical}` : CANONICAL_BASE + window.location.pathname);
  }, [title, description, canonical, noindex]);
}

export function StructuredData({ data }) {
  useEffect(() => {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.text = JSON.stringify(data);
    document.head.appendChild(s);
    return () => { document.head.removeChild(s); };
  }, [data]);
  return null;
}
